import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { useStore } from 'src/stores';
import { Autocomplete, TextField, Typography } from '@mui/material';
import useBillingTemplateModalContentStyles from '../styles';
import { Icon } from '@livable/saas-react-components';
import { singleElementOfArray } from 'src/utils/singleElementOfArray';
export const UtilitiesAutocomplete = observer(_ref => {
  let propertyUtility = _ref.propertyUtility,
    isCustomProviderMode = _ref.isCustomProviderMode,
    currentProviderDataExt = _ref.currentProviderDataExt;
  const classes = useBillingTemplateModalContentStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const store = useStore();
  const _useState = useState((propertyUtility === null || propertyUtility === void 0 ? void 0 : propertyUtility.utilityTypes.map(utType => {
      return _objectSpread(_objectSpread({}, utType), {}, {
        id: utType.utilityTypeId,
        label: utType.utilityTypeName
      });
    })) || []),
    _useState2 = _slicedToArray(_useState, 2),
    currentTemplateUtilities = _useState2[0],
    setCurrentTemplateUtilities = _useState2[1];
  const _useState3 = useState(currentProviderDataExt || null),
    _useState4 = _slicedToArray(_useState3, 2),
    currentProviderData = _useState4[0],
    setCurrentProviderData = _useState4[1];
  const _useState5 = useState(''),
    _useState6 = _slicedToArray(_useState5, 2),
    utilityInputValue = _useState6[0],
    setUtilityInputValue = _useState6[1];
  const getUnselectedUtilitiesOptions = (event, valueExt) => {
    if (currentProviderData === null) {
      return [];
    }
    const value = valueExt || utilityInputValue;
    if (value && value.length > 0 && isCustomProviderMode) {
      var _currentProviderData$;
      return [{
        id: 'customUtilityId' + '_' + utilityInputValue,
        key: 'customUtilityKey' + '_' + utilityInputValue,
        label: utilityInputValue + ' (Create Custom Utility)',
        inputName: utilityInputValue,
        isCustom: true
      }, ...(currentProviderData === null || currentProviderData === void 0 || (_currentProviderData$ = currentProviderData.utilities.map(utType => {
        if (isCustomProviderMode) {
          if (propertyUtility.propertyUtilityId !== 'NEW_TEMPLATE') {
            return _objectSpread(_objectSpread({}, utType), {}, {
              id: utType.utilityTypeId,
              key: utType.utilityTypeId,
              label: utType.name,
              utilityTypeName: utType.name
            });
          }
          return utType;
        }
        return _objectSpread(_objectSpread({}, utType), {}, {
          id: utType.utilityTypeId,
          key: utType.utilityTypeId,
          label: utType.name,
          utilityTypeName: utType.name
        });
      })) === null || _currentProviderData$ === void 0 ? void 0 : _currentProviderData$.filter(i => {
        return currentTemplateUtilities.findIndex(selectedUT => selectedUT.id === i.id) === -1;
      }))];
    } else {
      return (currentProviderData === null || currentProviderData === void 0 ? void 0 : currentProviderData.utilities.map(utType => {
        if (isCustomProviderMode) {
          if (propertyUtility.propertyUtilityId !== 'NEW_TEMPLATE') {
            return _objectSpread(_objectSpread({}, utType), {}, {
              id: utType.utilityTypeId,
              key: utType.utilityTypeId,
              label: utType.name,
              utilityTypeName: utType.name
            });
          }
          return utType;
        }
        return _objectSpread(_objectSpread({}, utType), {}, {
          id: utType.utilityTypeId,
          key: utType.utilityTypeId,
          label: utType.name,
          utilityTypeName: utType.name
        });
      }).filter(i => {
        return currentTemplateUtilities.findIndex(selectedUT => selectedUT.id === i.id) === -1;
      })) || [];
    }
  };
  const fetchUtilityInfos = async currentProviderExt => {
    var _store$homeDashboardS, _currentProviderExt$u, _currentProviderData$2;
    await ((_store$homeDashboardS = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS === void 0 ? void 0 : _store$homeDashboardS.fetchUtilitiesInfo((currentProviderExt === null || currentProviderExt === void 0 || (_currentProviderExt$u = currentProviderExt.utilities) === null || _currentProviderExt$u === void 0 ? void 0 : _currentProviderExt$u.map(ut => ut.id)) || (currentProviderData === null || currentProviderData === void 0 || (_currentProviderData$2 = currentProviderData.utilities) === null || _currentProviderData$2 === void 0 ? void 0 : _currentProviderData$2.map(ut => ut.id))));
  };
  const fetchProvider = async () => {
    if (isCustomProviderMode && propertyUtility.propertyUtilityId === 'NEW_TEMPLATE') {
      const resp = await store.utilityProviders.getAllUtilityTypesAsync.run({}, [propertyUtility.propertyUtilityId]);
      if (resp !== null && resp !== void 0 && resp.isSuccessful) {
        var _store$homeDashboardS2;
        propertyUtility.provider.setGenericUtilities(resp.response.map(utType => {
          return _objectSpread(_objectSpread({}, utType), {}, {
            id: utType.utilityTypeId,
            label: utType.utilityTypeName
          });
        }));
        setCurrentProviderData({
          utilities: resp.response.map(utType => {
            return _objectSpread(_objectSpread({}, utType), {}, {
              id: utType.utilityTypeId,
              label: utType.utilityTypeName
            });
          })
        });
        (_store$homeDashboardS2 = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS2 === void 0 || _store$homeDashboardS2.setUtilitiesInfoForCustomProvider(resp.response.map(utType => {
          return _objectSpread(_objectSpread({}, utType), {}, {
            utilityId: utType.utilityTypeId,
            providerName: 'CUSTOM_PROVIDER'
          });
        }));
      }
      return;
    }
    if (currentProviderData === null) {
      await store.utilityProviders.getUtilityProvidersListDataAsync.run({
        utilityProviderIds: [propertyUtility.provider.utilityProviderId]
      }).then(async resp => {
        if (resp !== null && resp !== void 0 && resp.isSuccessful) {
          setCurrentProviderData(singleElementOfArray(resp.response));
          await fetchUtilityInfos(singleElementOfArray(resp.response));
        }
      });
    } else {
      await fetchUtilityInfos();
    }
  };
  const updateBillingTemplateInitials = () => {
    var _store$homeDashboardS3, _propertyUtility$util;
    propertyUtility.updateProviderModalInitials((_store$homeDashboardS3 = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS3 === void 0 ? void 0 : _store$homeDashboardS3.getUtilityInfoById(propertyUtility === null || propertyUtility === void 0 || (_propertyUtility$util = propertyUtility.utilityTypes[0]) === null || _propertyUtility$util === void 0 ? void 0 : _propertyUtility$util.utilityTypeId));
  };
  useEffect(() => {
    fetchProvider();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isCustomProviderMode]);
  useEffect(() => {
    setCurrentProviderData(currentProviderDataExt);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentProviderDataExt === null || currentProviderDataExt === void 0 ? void 0 : currentProviderDataExt.id]);
  const TagModalChip = props => {
    return /*#__PURE__*/React.createElement("div", {
      className: classes.tagChip
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.tagChipTitle
    }, props.label), /*#__PURE__*/React.createElement("div", {
      className: classes.tagChipDelete,
      onClick: props.onDelete
    }, /*#__PURE__*/React.createElement(Icon, {
      type: "close"
    })));
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classes.xlSection
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, t('add_new_property_flow.please_setup_utilities'))), /*#__PURE__*/React.createElement("div", {
    className: classes.smSection
  }, /*#__PURE__*/React.createElement(Autocomplete, {
    multiple: true,
    variant: "plain",
    id: "utilities-list",
    disabled: store.utilityProviders.getAllUtilityTypesAsync.inProgress || store.utilityProviders.getUtilityInfoAsync.inProgress || store.utilityProviders.getUtilityProvidersListDataAsync.inProgress,
    value: currentTemplateUtilities,
    options: getUnselectedUtilitiesOptions(),
    renderInput: params => /*#__PURE__*/React.createElement(TextField, _extends({}, params, {
      label: store.utilityProviders.getAllUtilityTypesAsync.inProgress || store.utilityProviders.getUtilityInfoAsync.inProgress || store.utilityProviders.getUtilityProvidersListDataAsync.inProgress ? t('general.loading') : t('add_new_property_flow.utilities')
    })),
    renderOption: (props, option) => {
      return /*#__PURE__*/React.createElement("li", _extends({}, props, {
        key: props.id + '_' + option.id
      }), option.label);
    },
    renderTags: (tagValue, getTagProps) => {
      return tagValue.map((option, index) => /*#__PURE__*/React.createElement(TagModalChip, _extends({}, getTagProps({
        index
      }), {
        label: option.name || option.label
      })));
    },
    inputValue: utilityInputValue,
    onInputChange: (event, newInputValue) => {
      event === null || event === void 0 || event.preventDefault();
      event === null || event === void 0 || event.stopPropagation();
      setUtilityInputValue(newInputValue);
      // getUnselectedUtilitiesOptions(event, newInputValue);
    },
    onChange: (e, value, situation, option) => {
      switch (situation) {
        case 'blur':
          {
            break;
          }
        case 'createOption':
          {
            break;
          }
        case 'clear':
          {
            // disable all
            // console.log('UtilitiesAutocomplete disable all', option);
            setCurrentTemplateUtilities([]);
            propertyUtility.removeUtilityType('all');
            if (propertyUtility.propertyUtilityId === 'NEW_TEMPLATE') {
              // propertyUtility.removeUtilityType('all');
            }
            break;
          }
        case 'selectOption':
          {
            var _option$option, _option$option2;
            // enable utility
            console.log('UtilitiesAutocomplete selectOption', option);
            // NOTE: START - this if for creating correct custom utility object
            if ((_option$option = option.option) !== null && _option$option !== void 0 && (_option$option = _option$option.inputName) !== null && _option$option !== void 0 && _option$option.length) {
              option.option.label = option.option.inputName;
            }
            if (!(option !== null && option !== void 0 && (_option$option2 = option.option) !== null && _option$option2 !== void 0 && (_option$option2 = _option$option2.utilityTypeId) !== null && _option$option2 !== void 0 && _option$option2.length) && !!(option !== null && option !== void 0 && option.option.id.length)) {
              option.option.utilityTypeId = option.option.id;
            }
            // NOTE: END - this if for creating correct custom utility object
            setCurrentTemplateUtilities([...currentTemplateUtilities, option.option]);
            propertyUtility.addUtilityType(option.option);
            if (propertyUtility.propertyUtilityId === 'NEW_TEMPLATE') {
              updateBillingTemplateInitials();
            }
            break;
          }
        case 'removeOption':
          {
            // disable utility
            // console.log('UtilitiesAutocomplete disable utility', option);
            setCurrentTemplateUtilities([...currentTemplateUtilities.filter(ut => ut.id !== option.option.id)]);
            propertyUtility.removeUtilityType(option.option);
            if (propertyUtility.propertyUtilityId === 'NEW_TEMPLATE') {
              updateBillingTemplateInitials();
            }
            break;
          }
      }
    }
  })));
});